// src/AppLayout.js
import React from "react";
import { Outlet } from "react-router-dom";

export default function AppLayout() {
  return (
    <div className="app-shell bg-blue-50">
      <Outlet />       
    </div>
  );
}
